import axios from "axios";

export const fetchCountries = async () => {
  return await axios({
    url: "https://restcountries.com/v3.1/all",
    method: "GET",
  });
};
